import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../shared/area-restitra.shared.module';
import { AlteracaoSenhaComponent } from './alteracao-senha/alteracao-senha.component';
import { CodigoAcessoComponent } from './codigo-acesso/codigo-acesso.component';
import { RecuperarSenhaComponent } from './recuperar-senha.component';
import { RecuperarSenhaRoutingModule } from './route/recuperar-senha.routing.module';
import { RecuperarSenhaService } from './service/recuperar-senha.service';
import { DataTableModule } from 'primeng/primeng';
import { EnderecoCentrusService } from '../shared/services/endereco-centrus.service';


@NgModule({
  imports: [
    CommonModule,
    AreaRestritaSharedModule,
    RecuperarSenhaRoutingModule,
    DataTableModule
  ],
  declarations: [
    RecuperarSenhaComponent,
    CodigoAcessoComponent,
    AlteracaoSenhaComponent
  ],
  providers: [
    RecuperarSenhaService
  ],
  exports: [
    CodigoAcessoComponent,
    AlteracaoSenhaComponent,
    RecuperarSenhaComponent
  ]
})
export class RecuperarSenhaModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/recuperar-senha.module.ts